import moment from 'moment'

/* will remove this file. Need to import this file from apex-ui-kit */
const isValid = val => {
  return val || val === 0
}

const bracketsFormatter = params => {
  if (isValid(params.value)) {
    return '(' + params.value + ')'
  }
  return ''
}

const formatNumber = val => {
  // this puts commas into the number eg 1000 goes to 1,000,
  if (isValid(val)) {
    return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }
  return ''
}

const currencyFormatter = params => {
  if (isValid(params.value)) {
    return '$' + formatNumber(Number(params.value).toFixed(0))
  }
  return ''
}

const currencyDecimalFormatter = params => {
  if (isValid(params.value)) {
    return '$' + formatNumber(Number(params.value).toFixed(2))
  }
  return ''
}

const currencyThreeDecimalFormatter = params => {
  if (isValid(params.value)) {
    return '$' + formatNumber(Number(params.value).toFixed(3))
  }
  return ''
}

const numberFormatter = params => {
  if (isValid(params.value)) {
    return formatNumber(Number(params.value).toFixed(0))
  }
  return ''
}

const decimalWithCommaToFixedTwoFormatter = params => {
  if (isValid(params.value)) {
    return formatNumber(Number(params.value).toFixed(2))
  }
  return ''
}

const decimalWithCommaToFixedThreeFormatter = params => {
  if (isValid(params.value)) {
    return formatNumber(Number(params.value).toFixed(3))
  }
  return ''
}

const percentFormatter = params => {
  if (isValid(params.value)) {
    return Number(params.value).toFixed(0) + '%'
  }
  return ''
}

const percentDecimalFormatter = params => {
  if (isValid(params.value)) {
    return Number(params.value).toFixed(2) + '%'
  }
  return ''
}

const defaultFormatter = params => {
  var pv = params.value
  if (isValid(params.value)) {
    return pv
  }
  return ''
}

const booleanFormatter = ({ value }) => {
  if (isValid(value) && value !== 'false') {
    return 'Yes'
  }
  return 'No'
}

const decimalRoundOffFormatter = ({ value }) => {
  if (isValid(value)) {
    if (value < 0) {
      return 0
    } else if (value % 1 !== 0) {
      return Math.ceil(value)
    }
    return value
  }
}

const dateFormatter = ({ value }) => {
  if (isValid(value)) {
    return moment(value).format('MM/DD/YYYY')
  }
}

const integerWithoutCommaFormatter = params => {
  if (isValid(params.value)) {
    return Number(params.value).toFixed(0)
  }
}

const currencyDecimalWithoutCommaFormatter = params => {
  if (isValid(params.value)) {
    return '$' + Number(params.value).toFixed(2)
  }
  return ''
}

const decimalToFixedOneFormatter = params => {
  if (isValid(params.value)) {
    return Number(params.value).toFixed(1)
  }
  return ''
}

const decimalToFixedTwoFormatter = params => {
  if (isValid(params.value)) {
    return Number(params.value).toFixed(2)
  }
  return ''
}
const decimalToFixedThreeFormatter = params => {
  if (isValid(params.value)) {
    return Number(params.value).toFixed(3)
  }
  return ''
}
const decimalToFixedFourFormatter = params => {
  if (isValid(params.value)) {
    return Number(params.value).toFixed(4)
  }
  return ''
}
const decimalToFixedFiveFormatter = params => {
  if (isValid(params.value)) {
    return Number(params.value).toFixed(5)
  }
  return ''
}

const getValueFormatter = (valueFormatter, format) => {
  if (valueFormatter) {
    return assignFormatter(valueFormatter)
  }
  switch (format) {
    case '0':
      return assignFormatter('integerWithoutCommaFormatter')
    case '0,0':
      return assignFormatter('numberFormatter')
    case '0.0':
      return assignFormatter('decimalToFixedOneFormatter')
    case '0.00':
      return assignFormatter('decimalToFixedTwoFormatter')
    case '0,0.00':
      return assignFormatter('decimalWithCommaToFixedTwoFormatter')
    case '0.000':
      return assignFormatter('decimalToFixedThreeFormatter')
    case '0,0.000':
      return assignFormatter('decimalWithCommaToFixedThreeFormatter')
    case '0.0000':
      return assignFormatter('decimalToFixedFourFormatter')
    case '0.00000':
      return assignFormatter('decimalToFixedFiveFormatter')
    case '$0.00':
      return assignFormatter('currencyDecimalWithoutCommaFormatter')
    case '$0,0.00':
      return assignFormatter('currencyDecimalFormatter')
    case '$0,0.000':
      return assignFormatter('currencyThreeDecimalFormatter')
    case '0.00%':
      return assignFormatter('percentDecimalFormatter')
    default:
      return assignFormatter('defaultFormatter')
  }
}

const assignFormatter = type => {
  switch (type) {
    case 'bracketsFormatter':
      return bracketsFormatter
    case 'currencyFormatter':
      return currencyFormatter
    case 'currencyDecimalFormatter':
      return currencyDecimalFormatter
    case 'currencyThreeDecimalFormatter':
      return currencyThreeDecimalFormatter
    case 'numberFormatter':
      return numberFormatter
    case 'decimalWithCommaToFixedTwoFormatter':
      return decimalWithCommaToFixedTwoFormatter
    case 'decimalWithCommaToFixedThreeFormatter':
      return decimalWithCommaToFixedThreeFormatter
    case 'percentFormatter':
      return percentFormatter
    case 'percentDecimalFormatter':
      return percentDecimalFormatter
    case 'decimalRoundOffFormatter':
      return decimalRoundOffFormatter
    case 'booleanFormatter':
      return booleanFormatter
    case 'dateFormatter':
      return dateFormatter
    case 'integerWithoutCommaFormatter':
      return integerWithoutCommaFormatter
    case 'currencyDecimalWithoutCommaFormatter':
      return currencyDecimalWithoutCommaFormatter
    case 'decimalToFixedOneFormatter':
      return decimalToFixedOneFormatter
    case 'decimalToFixedTwoFormatter':
      return decimalToFixedTwoFormatter
    case 'decimalToFixedThreeFormatter':
      return decimalToFixedThreeFormatter
    case 'decimalToFixedFourFormatter':
      return decimalToFixedFourFormatter
    case 'decimalToFixedFiveFormatter':
      return decimalToFixedFiveFormatter
    default:
      return defaultFormatter
  }
}

export { assignFormatter, getValueFormatter }
